import { ShipDesign, ShipCustomization } from './types';

const STORAGE_KEY = 'pirate_ships_designs';
const CURRENT_DESIGN_KEY = 'pirate_ships_current';

export const storageUtils = {
  getDesigns: (): ShipDesign[] => {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  },

  saveDesign: (design: ShipDesign): void => {
    try {
      const designs = storageUtils.getDesigns();
      const index = designs.findIndex((d) => d.id === design.id);

      if (index >= 0) {
        designs[index] = design;
      } else {
        designs.push(design);
      }

      localStorage.setItem(STORAGE_KEY, JSON.stringify(designs));
    } catch {
      console.error('Failed to save design');
    }
  },

  deleteDesign: (id: string): void => {
    try {
      const designs = storageUtils.getDesigns();
      const filtered = designs.filter((d) => d.id !== id);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
    } catch {
      console.error('Failed to delete design');
    }
  },

  getCurrentCustomization: (): ShipCustomization => {
    try {
      const data = localStorage.getItem(CURRENT_DESIGN_KEY);
      return data
        ? JSON.parse(data)
        : {
            hullColor: '#8B4513',
            hullStyle: 'merchant',
            sailColor: '#f0f0f0',
            sailPattern: 'plain',
            figurehead: 'skull',
            flagColor: '#000000',
            flagPattern: 'jollyroger',
          };
    } catch {
      return {
        hullColor: '#8B4513',
        hullStyle: 'merchant',
        sailColor: '#f0f0f0',
        sailPattern: 'plain',
        figurehead: 'skull',
        flagColor: '#000000',
        flagPattern: 'jollyroger',
      };
    }
  },

  saveCurrentCustomization: (customization: ShipCustomization): void => {
    try {
      localStorage.setItem(CURRENT_DESIGN_KEY, JSON.stringify(customization));
    } catch {
      console.error('Failed to save current customization');
    }
  },
};
